import * as actionTypes from "./actionTypes";

const setNivelInscripcion = data => {
  if (data === undefined || data === null) {
    return {
      type: actionTypes.FETCH_NIVELINSCRIPCION_SUCCESS,
      nivelInscripcion: []
    };
  }
  return {
    type: actionTypes.FETCH_NIVELINSCRIPCION_SUCCESS,
    nivelInscripcion: data
  };
};

export const filterNivelInscripcion = (language = null) => {
  let data = null;
  if (language === "en") {
    data = [
      {
        id: 1,
        nombre: "Level I"
      },
      {
        id: 2,
        nombre: "Level II"
      }
    ];
  } else {
    data = [
      {
        id: 1,
        nombre: "Nivel I"
      },
      {
        id: 2,
        nombre: "Nivel II"
      }
    ];
  }
  return dispatch => {
    dispatch(setNivelInscripcion(data));
  };
};
